// components/ScrollButtons.jsx
import React from "react";
import IconButton from "../../../ui/Button/IconButton.jsx";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * ScrollButtons - Navigation buttons for scrollable featured events carousel
 * 
 * Displays left/right navigation buttons for horizontal scrolling.
 * Buttons only appear when scrolling is possible in that direction.
 * 
 * @component
 * @param {Object} props
 * @param {boolean} props.showLeftScroll - Whether to show left scroll button
 * @param {boolean} props.showRightScroll - Whether to show right scroll button
 * @param {Function} props.onScroll - Callback when scroll button is clicked (direction)
 * 
 * @example
 * <ScrollButtons
 *   showLeftScroll={canScrollLeft}
 *   showRightScroll={canScrollRight}
 *   onScroll={(direction) => scroll(direction)}
 * />
 */

const ScrollButtons = ({ showLeftScroll, showRightScroll, onScroll }) => (
  <>
    {showLeftScroll && (
      <IconButton
        icon={<ChevronLeft className="w-6 h-6" />}
        variant="favorite"
        size="iconMd"
        onClick={() => onScroll("left")}
        withMotion={false}
        className="absolute left-2 top-1/2 transform -translate-y-1/2  "
      />
    )}
    {showRightScroll && (
      <IconButton
        icon={<ChevronRight className="w-6 h-6" />}
        variant="favorite"
        size="iconMd"
        onClick={() => onScroll("right")}
        withMotion={false}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 "
      />
    )}
  </>
);


export default ScrollButtons;
